import { render, staticRenderFns } from "./PrivateJob.vue?vue&type=template&id=bc455538&scoped=true&"
import script from "./PrivateJob.vue?vue&type=script&lang=js&"
export * from "./PrivateJob.vue?vue&type=script&lang=js&"
import style0 from "./PrivateJob.vue?vue&type=style&index=0&id=bc455538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc455538",
  null
  
)

export default component.exports